import { MileageWarrantiesRange, PriceRange } from "types/search";
import { Tire } from "types/tire";

export const isPriceInRange = (priceRange: PriceRange[], tire: Tire) => {
  for (let i = 0; i < priceRange.length; i++) {
    if (
      priceRange[i]?.MaxPrice >= tire._finalPrice &&
      priceRange[i]?.MinPrice <= tire._finalPrice
    ) {
      return true;
    }
  }
  return false;
};

export const isWarrantyInRange = (
  mileageWarrantiesRange: MileageWarrantiesRange[],
  tire: Tire
) => {
  for (let i = 0; i < mileageWarrantiesRange.length; i++) {
    if (mileageWarrantiesRange[i]?.MinMiles <= tire.WarrantySort) {
      return true;
    }
  }
  return false;
};


export const isTireTypeIncluded = (
    tireTypes: string[],
    tire: Tire
) => {
    for (let i = 0; i < tireTypes.length; i++) {
        if (tireTypes[i] === "Winter") {
            if (tire.Winter) {
                return true;
            }            
        }

        if (tireTypes[i] === "Road Hazard") {
            if (tire.HasRoadHazard) {
                return true;
            }
        }

        if (tireTypes[i] === "Severe Snow Service") {
            if (tire.Is3PMSF) {
                return true;
            }
        }

        if (tireTypes[i] === "Run Flat") {
            if (tire.RunFlat) {
                return true;
            }
        }

        if (tireTypes[i] === "Trailer Tires") {
            if (Array.isArray(tire.TireTypes) && tire.TireTypes.some(type => type === "TRAILER")) {
                return true;
            }
        }
    }
    
    return false;
};